<template>
  <div class="job-create f-c" v-loading="loadingData">
    <basic-form ref="jobForm" title="Job Info" :mode="FormModes.SPARSE" :form-params="jobForm"
      :value-change-cb="jobFormChange" showClear>
      <template v-slot:actions>
        <el-button type="primary" size="small" @click="doCreateJob">
          Create Job
        </el-button>
      </template>
    </basic-form>
    <job-content-create v-if="jobType === UnloadingJob" ref="jobContentCreate" :goodQuery="{ containerId }"
      :groupsChanged="groupsChanged" class="job-content-create" />
    <div v-else-if="jobType === ScanPalletJob">
      // not implemented
    </div>
    <job-content-create-with-pallet ref="jobContentCreateWithPallet" :job-type="jobType" v-else />
    <common-card title="Job Content" class="job-content-card" v-if="jobType === UnloadingJob">
      <job-content :job-content="jobContent" :has-actions="false" :job-status="JobUnassigned"
        :show-pallet-list="false" />
    </common-card>
    <div class="buttons f-r">
      <el-button type="danger" size="small" @click="cancelCreate">
        Cancel Create
      </el-button>
      <el-button type="primary" size="small" @click="doCreateJob">
        Create Job
      </el-button>
    </div>
  </div>
</template>
<script>
// others
import cloneDeep from 'lodash/cloneDeep'
import { FormModes } from '@/core/configs/types'
// apis
import { createJob } from '@/api/job'
// mixin
import { pageJumps } from '@/core/mixin/pages'
// models
import { JobForm, GoodsGroupWrapUp } from '@/core/models/job'
import {
  UnloadingJob,
  ScanPalletJob,
  InboundJob,
  JobUnassigned,
  OutboundJob
} from '@/core/models/constant'
// components
import CommonCard from '@/components/common/CommonCard.vue'
import BasicForm from '@/components/common/BasicForm.vue'
import JobContentCreate from '@/components/jobs/JobContentCreate.vue'
import JobContentCreateWithPallet from '@/components/jobs/JobContentCreateWithPallet.vue'
import JobContent from '@/components/jobs/JobContent'
export default {
  name: 'JobCreate',
  components: {
    CommonCard,
    BasicForm,
    JobContentCreate,
    JobContentCreateWithPallet,
    JobContent
  },
  mixins: [pageJumps],
  data() {
    return {
      FormModes,
      JobUnassigned,
      UnloadingJob,
      ScanPalletJob,
      jobForm: cloneDeep(JobForm),
      jobContent: [],
      riiOrderNo: '',
      loadingData: false
    }
  },
  created() {
    this.jobForm.type.value = this.jobType
    this.jobForm.type.default = this.jobType
    this.jobForm.riiOrderNo.value = this.orderNo
    if (this.jobType !== UnloadingJob && this.jobType !== ScanPalletJob) {
      delete this.jobForm.riiOrderNo
    }
  },
  watch: {},
  computed: {
    jobType() {
      return this.$route.query?.jobType ?? UnloadingJob
    },
    orderNo() {
      return this.$route.query?.orderNo ?? ''
    },
    containerId() {
      return this.$route.query?.containerId ?? ''
    }
  },
  methods: {
    jobFormChange() { },
    cancelCreate() {
      this.goBack()
    },
    groupsChanged(goodsGroups, goodsMap) {
      this.jobContent = Object.values(goodsGroups).map(group => {
        return GoodsGroupWrapUp(
          group,
          group.goodsIds.map(key => goodsMap[key])
        )
      })
    },
    doCreateJob() {
      this.$confirm(
        'Please make sure goods without shipping destination are hold, continue?',
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          this.createJob()
        })
        .catch(() => { })
    },
    createJob() {
      // first get job content
      // then pack up job info
      let passed, jobInfo
        ;[passed, jobInfo] = this.$refs.jobForm.validateAllInputs()
      if (!passed) return
      let goodsGroups = []
      let selectedPallets = []
      switch (this.jobType) {
        case UnloadingJob:
          passed = this.$refs.jobContentCreate.checkGroupValid()
          if (!passed) {
            this.$message({
              type: 'error',
              message: 'you have goods in packing list to be categorized!'
            })
            return
          }
          goodsGroups = this.jobContent.map(group => {
            return {
              ...group,
              addressId: group.address?.id,
              goods: group.goodsList.map(one => one.id),
              goodsList: undefined,
              goodsIds: undefined,
              address: undefined
            }
          })
          break
        case InboundJob:
        case OutboundJob:
          selectedPallets =
            this.$refs.jobContentCreateWithPallet.getSelectedPalletIds()
          break
      }
      this.loadingData = true
      createJob({
        ...jobInfo,
        type: this.jobType,
        riiOrderNo: this.orderNo,
        goodsGroups: goodsGroups,
        selectedPallets: selectedPallets
      }).then(res => {
        this.loadingData = false
        if (res) {
          this.$message({
            type: 'success',
            message: `Successfully created a ${this.jobType} job!`
          })
          this.goToJobDetail(res.no)
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';

$draggable-list-min-height: 350px;

.job-create {
  .job-content-create {
    @extend .global-margin;
  }

  .buttons {
    gap: 10px;
    justify-content: end;
    margin-right: 20px;
    margin-bottom: 40px;
  }
}
</style>
